<template>
	<div v-if="Object.keys(loanDetail).length" class="month-payment">
		<div class="section-label">计算结果</div>
		<FinanceResult
			:overviewList="customOverviewList"
			:details="details"
			:periodDetailInfos="periods"
			:monthlyInstallmentInfos="monthlyInstallmentList"
		/>
		<p v-if="description" class="plan-description">{{ description }}</p>
	</div>
</template>

<script>
import FinanceResult from '../FinanceResult.vue'

export default {
	name: 'MonthPayment',
	components: { FinanceResult },
	props: {
		loanDetail: { type: Object, default: () => ({}) },
		description: { type: String, default: '' }
	},
	computed: {
		customOverviewList() {
			const detail = this.loanDetail
			return [
				{ amount: this.formatMoney(detail.loan_payment), label: '贷款/融资金额' },
				{ amount: this.formatMoney(detail.loan_commission), label: '总利息' }
			]
		},
		// 分段的明细信息 1-11期，11-21期，依此类推
		periods() {
			return this.loanDetail.step_detail_info_vos || []
		},
		// 月供明细信息
		monthlyInstallmentList() {
			return this.loanDetail.monthly_installment_list || []
		},
		details() {
			const detail = this.loanDetail
			let detailInfos = [
				{ name: '首付', value: detail.down_payment, code: 'money' },
				{ name: '期限', value: detail.quantity, code: 'month' },
				{
					name: '月供/月租金',
					value: detail.money,
					code: 'money',
					discount: detail.has_discount ? detail.discount_amount : null
				},
				{ name: '尾款金额', value: detail.complete_money, code: 'money' },
				{ name: '尾款利息', value: detail.complete_commission, code: 'money' },
				{ name: '一次性手续费', value: detail.commission, code: 'money' },
				{
					name: '年化费率',
					value: detail.loan_annualized_rate,
					code: 'annualized_rate',
					discount: detail.has_discount ? detail.annualized_rate : null
				},
				{
					name: '折合年化利率',
					value: detail.interest_rate,
					code: 'interest_rate',
					discount: detail.has_discount ? detail.product_interest_rate : null
				}
			]
			detailInfos = detailInfos.filter(item => item.value)

			// 如果存在月供明细，则移除“月供/月租金”项
			if (this.monthlyInstallmentList.length) {
				detailInfos = detailInfos.filter(item => item.name != '月供/月租金')
			}
			// 如果存在分期信息，则移除“月供/月租金”、“折合年化利率”和“年化费率”项
			if (this.periods.length) {
				detailInfos = detailInfos.filter(
					item =>
						item.name != '月供/月租金' && item.name != '折合年化利率' && item.name != '年化费率'
				)
			}

			return detailInfos
		}
	},
	methods: {
		formatMoney(value) {
			return value === undefined || value === null
				? '--'
				: '¥' + Math.round(Number(value)).toLocaleString('en-US')
		}
	}
}
</script>

<style scoped lang="scss">
@import '~@nio-fe/nio-app-ui/es/style';
.month-payment {
	margin-top: 40px;
	padding: 0 20px;
}
.section-label {
	@include subtitle_2(1.5, 500, false);
}
.plan-description {
	color: #999dae;
	@include body_3(1.5, 400, false);
}
.period-section {
	margin-top: 16px;
}
.plan-description {
	margin: 16px 0 0;
}
</style>
